import { FC } from "react";

interface GoalProgressBarProps {
  progress: number;
  colorClass: string;
}

export const GoalProgressBar: FC<GoalProgressBarProps> = ({
  progress,
  colorClass,
}) => {
  return (
    <div className="h-2 flex-1 overflow-hidden rounded-full bg-gray-100">
      <div
        className={`h-full transition-all duration-300 ${colorClass}`}
        style={{ width: `${Math.min(progress, 100)}%` }}
      />
    </div>
  );
};
